/**
 * session storage
 */

export default class SSTORAGE{

    get _isOpeningViewed(){
        return sessionStorage.getItem('opening_viewed');
    }

    set _isOpeningViewed(val){
        sessionStorage.setItem('opening_viewed', val);
    }
}
